import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Col, Row } from 'reactstrap';
import renderSelectField from 'src/shared/components/form/Select';
import { connect, useSelector } from 'react-redux';
import MerchantCustomerDetails from './MerchantCustomerDetails';
import { ADDRESS_TYPE_MERCHANT_CUSTOMER } from 'src/utils/pnd/PndConstants';
import MerchantDropOffRequiredLaterCustomerInfo from './MerchantDropOffRequiredLaterCustomerInfo';

const required = value => value ? undefined : 'Required';

const MerchantPickAndDrop = ({ isCustomersId, isMerchantPickUpPoint, isInfo }) => {
    const [isSelectedPickUpPoint, setSelectedPickUPPoint] = useState(false);
    const [isMerchantDropOffPoint, setMerchantDropOffPoint] = useState(false);

    const formOrderFromAddressType = useSelector(
        state => state.form?.orderForm?.values?.orderFromAddressTypeInfo
    );
    const formOrderToAddressType = useSelector(
        state => state.form?.orderForm?.values?.orderToAddressTypeInfo
    );

    useEffect(() => {
        const fromTypeId = Number(
            isInfo?.orderFromAddressTypeInfo?.orderAddressTypeId ??
            isInfo?.orderFromAddressTypeId ??
            isInfo?.fromAddressTypeId
        );
        if (fromTypeId === ADDRESS_TYPE_MERCHANT_CUSTOMER || isInfo?.orderFromAddressTypeInfo?.label === "Merchant Customer" || (!isInfo?.collectionPointId && isInfo?.name)) {
            setSelectedPickUPPoint(true);
        }
        const toTypeId = Number(
            isInfo?.orderToAddressTypeInfo?.orderAddressTypeId ??
            isInfo?.orderToAddressTypeId ??
            isInfo?.toAddressTypeId
        );
        if (toTypeId === ADDRESS_TYPE_MERCHANT_CUSTOMER || isInfo?.orderToAddressTypeInfo?.label === "Merchant Customer" || isInfo?.toAddressName) {
            setMerchantDropOffPoint(true);
        }
    }, [isInfo]);

    const isPickupCustomer = isSelectedPickUpPoint ||
        formOrderFromAddressType?.value === 0 ||
        formOrderFromAddressType?.label === "Merchant Customer" ||
        formOrderFromAddressType?.value === 5;

    const isDropoffCustomer = isMerchantDropOffPoint ||
        formOrderToAddressType?.value === 5 ||
        formOrderToAddressType?.label === "Merchant Customer";

    const checkPickUpPoint = (value) => {
        setSelectedPickUPPoint(value === 0 || value === 5);
    };

    const checkDropOffPoint = (value) => {
        setMerchantDropOffPoint(true);
    };

    return (
        <>
            <Row className="g-2 mb-3">
                <Col lg={4} md={6}>
                    <div className="mb-1">
                        <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Pick Up From <span className='text-danger'>*</span></label>
                        <Field
                            validate={[required]}
                            name="orderFromAddressTypeInfo"
                            component={renderSelectField}
                            options={isMerchantPickUpPoint}
                            placeholder="Select Pick Up Point"
                            onChange={event => checkPickUpPoint(event?.value)}
                        />
                    </div>
                </Col>

                {!isPickupCustomer && isInfo && isInfo?.collectionPointId && (
                    <Col lg={4} md={6}>
                        <div className="mb-1">
                            <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Pick Up Location <span className='text-danger'>*</span></label>
                            <Field
                                validate={[required]}
                                name="collectionPointId"
                                component={renderSelectField}
                                options={isMerchantPickUpPoint}
                                placeholder="Select Pick Up Point"
                                isDisabled={!!isInfo?.orderNo}
                            />
                        </div>
                    </Col>
                )}

                <Col lg={4} md={6}>
                    <div className="mb-1">
                        <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Drop Off To <span className='text-danger'>*</span></label>
                        <Field
                            validate={[required]}
                            name="orderToAddressTypeInfo"
                            component={renderSelectField}
                            options={[{ "value": 5, "label": "Merchant Customer" }]}
                            placeholder="Select Drop Off Point"
                            onChange={event => checkDropOffPoint(event?.value)}
                        />
                    </div>
                </Col>
            </Row>

            {(isPickupCustomer || isDropoffCustomer) && (
                <MerchantCustomerDetails isCustomersId={isCustomersId} />
            )}

            {(isPickupCustomer && isDropoffCustomer) && (
                <MerchantDropOffRequiredLaterCustomerInfo isCustomersId={isCustomersId} />
            )}
        </>
    );
};

MerchantPickAndDrop.propTypes = {
    isCustomersId: PropTypes.array,
    isMerchantPickUpPoint: PropTypes.array,
    isInfo: PropTypes.object,
};

export default connect()(reduxForm({
    form: "orderForm",
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: false,
})(MerchantPickAndDrop));
